import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getMember, updateMember, createMember } from '../services/api';
import MemberForm from '../components/MemberForm';

const MemberDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (id !== 'new') {
      (async () => {
        const { data } = await getMember(id, token);
        setMember(data);
      })();
    }
  }, [id]);

  const handleSubmit = async (form) => {
    if (id === 'new') {
      await createMember(form, token);
    } else {
      await updateMember(id, form, token);
    }
    navigate('/members');
  };

  return <MemberForm initialData={member} onSubmit={handleSubmit} />;
};

export default MemberDetail;